module.exports = __webpack_public_path__ + "img/home.a36399f3.jpg";